import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiroCards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGiroCards"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4V16H6V20H22V8H18V4H2ZM18 10V16H8V18H20V10H18ZM6 8H9V10H6V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiroCards;
